module.exports = __webpack_public_path__ + "img/medalha-compra-legal.c1b8436e.jpg";